<style lang="scss">
    .instructor-carousel{
        .swiper-container {
            width: 100%;
            height: 45vh;

            .swiper-nav{
                color: white;
                border-radius: 60px;
                width: 60px;
                height: 60px;

                &:after{
                    position: relative;
                }

                &.swiper-button-next:after{
                    left: 5px;
                }

                &.swiper-button-prev:after{
                    right: 3px;
                }
            }

            .swiper-slide {
                text-align: center;
                font-size: 18px;
                position: relative;
                max-width: 300px;

                &__img-wrapper{
                    height: 80%;

                    img{
                        width: 175px;
                        height: 175px;
                        object-fit: cover;
                        border: solid 4px black;
                        box-sizing: border-box;
                        border-radius: 90px;
                    }
                }

                .active-slide-only{
                    display: none;
                }

                &.swiper-slide-active{
                    .swiper-slide__img-wrapper{
                        border: 4px solid $purple-m;
                        background-color: rgba(255,255,255,0.4);
                        padding: 20px;
                        box-sizing: border-box;
                        border-radius: 30px;
                    }

                    .active-slide-only{
                        display: block;
                    }
                }

                &__name{
                    background-color: rgba(0,0,0,0.5);
                    margin-top: 15px;
                    font-size: 18pt;
                    border-radius: 10px;
                }

                .medi-btn-purple{
                    font-size: 1.2em;
                }
            }
        }

    }

</style>

<template>
    <div class="instructor-carousel">
        <div class="swiper-container" v-if="instructors.length > 0">
            <div class="swiper-wrapper">
                <div v-for="instructor in instructors" :key="instructor._id"
                     class="swiper-slide">
                    <div class="swiper-slide__img-wrapper d-flex flex-wrap justify-center align-center">
                        <img width="100%" height="100%" class="mb-2" :src="getAssetUrl(instructor.thumbnail)" alt="">

                        <v-btn
                                @click="$emit('start-experience', true)"
                                elevation="0" style="border-radius: 10px !important;"
                                class="medi-btn-purple active-slide-only py-1 mx-auto">
                            Start Experience
                        </v-btn>
                    </div>

                    <h3 class="swiper-slide__name white--text active-slide-only">{{instructor.name}}</h3>
                </div>
            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next swiper-nav"></div>
            <div class="swiper-button-prev swiper-nav"></div>
        </div>
    </div>
</template>

<script>
  import Swiper from 'swiper/bundle';
  import 'swiper/swiper-bundle.css'; // import Swiper styles

  export default {
    props: {
      instructors: {
        required: true,
        type: Array
      }
    },
    components: {},
    data() {
      return {
        swiper: null,
      };
    },
    mounted() {
      this.setUpCarousel();
    },
    methods: {
      setUpCarousel() {
        this.swiper = new Swiper('.swiper-container', {
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 60,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });

        this.swiper.on('click', (swiper) => {
          if(swiper.clickedSlide) {
            swiper.slideTo(swiper.clickedIndex);
          }
        });

        this.swiper.on('slideChange', (swiper) => {
          this.emitNewInstructorIndex(swiper.activeIndex);
        });

        setTimeout(() => {
          this.swiper.update();
        });
      },
      getAssetUrl(url) {
        if(url) {
          return require('../../../assets/'+ url);
        }
      },
      emitNewInstructorIndex(index) {
        this.$emit('new-instructor', index);
      }
    },
  };
</script>
